










































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import billingApi from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter, Mutation } from "vuex-class";

import { NSLog } from "@/helpers/log";
import PackageHelpers, { Package } from "@/models/package";
const log = NSLog("view/ManagePackages");

import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import FontPlugin from "@ckeditor/ckeditor5-font/src/font";

@Component({
  components: {
    loader
  }
})
export default class EditPackageDialog extends Vue {
  @Prop({ required: true }) public value: any;
  @Prop() public categories: any;

  public editor = ClassicEditor;
  public editorData = "<p>Content of the editor.</p>";
  public editorConfig = {
    plugins: [
      EssentialsPlugin,
      BoldPlugin,
      ItalicPlugin,
      ParagraphPlugin,
      FontPlugin
    ],

    toolbar: {
      items: ["bold", "italic", "undo", "redo", "fontSize"]
    }
  };

  @Mutation("setLastErr") public setLastErr: any;
  private saving = false;
  private valid = false;
  private item: Package = PackageHelpers.New();

  changed = false;
  public created() {
    this.item =
      this.value && this.value !== true
        ? Object.assign({}, this.value)
        : PackageHelpers.New();
    Vue.nextTick(() => this.changed = false)
  }

  @Watch("item", { deep: true }) watchChanged() {
    this.changed = true;
  }

  public dialogInput(v: any) {
    if (!v) {
      this.$emit("input", false);
    }
  }

  requiredNumber = [(v: any) => !!v || 'Required', (v: any) => (+v) > 0 || 'Must be > 0']
}
